var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.noLink)?[_c('span',[_vm._t("default")],2)]:[_c('router-link',_vm._b({},'router-link',_vm.$props,false),[_vm._t("default")],2)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }